import axiosInstance from './AxiosInstance';

const API_URL = '/crm-reports';

// The CRM menu's reports. `kind` is 'students' | 'batches'.
// Every figure, band and ordering arrives worked out from the API.
// `filters` is { status: 'ongoing' | 'completed' | 'all', from, to,
// studentStatus: 'all' | 'active' | 'inactive', courseId, trainerId }
// (dates as YYYY-MM-DD; studentStatus on the students report); the API
// applies them.

const filterParams = ({ status, from, to, studentStatus, courseId, trainerId } = {}) => ({
  status: status || undefined,
  from: from || undefined,
  to: to || undefined,
  studentStatus: studentStatus && studentStatus !== 'all' ? studentStatus : undefined,
  courseId: courseId || undefined,
  trainerId: trainerId || undefined,
});

// The Course / Trainer pickers' choices (`field`: 'course' | 'trainer'),
// a page at a time, as { data: [{ id, name }], pagination }.
export const getCrmReportOptions = async (field, page = 1, search = '', limit = 10) => {
  const response = await axiosInstance.get(`${API_URL}/options`, {
    params: { field, page, limit, search: search || undefined },
    silent: true,
    timeout: REPORT_TIMEOUT_MS,
  });
  return { data: response.data.data, pagination: response.data.pagination };
};

// The API holds these reports worked out in memory, but the first one
// after it starts reads every running batch's sessions and can take half
// a minute. AxiosInstance's 15s default cancelled exactly those requests.
const REPORT_TIMEOUT_MS = 120000;

// The cards and the one-line highlights.
export const getCrmReportSummary = async (kind, filters) => {
  const response = await axiosInstance.get(`${API_URL}/${kind}`, {
    params: filterParams(filters),
    timeout: REPORT_TIMEOUT_MS,
  });
  return response.data.data; // { cards, highlights, total }
};

// The rows behind one card, a page at a time.
export const getCrmReportList = async (kind, { group, page = 1, limit = 25, search = '', filters } = {}) => {
  const response = await axiosInstance.get(`${API_URL}/${kind}/list`, {
    params: { group, page, limit, search: search || undefined, ...filterParams(filters) },
    // The popup draws its own loading row; the global overlay stays down.
    silent: true,
    timeout: REPORT_TIMEOUT_MS,
  });
  return response.data; // { data: { group, rows }, pagination }
};
